import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/About";

const TITLE = "About Rex & Sons RVs | Family Owned RV Dealer in Wilmington NC";
const DESCRIPTION =
  "Meet the family behind Rex & Sons RVs — serving Wilmington and Castle Hayne, NC since 1997 with new & used RV sales, service, parts, rentals and storage.";
const URL = "https://www.rexandsonsrvs.com/about-us";
const IMAGE = "https://cpkvmigljcrjxctoixoq.supabase.co/storage/v1/object/public/splash-assets/hero-about-1920.webp";

export const Route = createFileRoute("/about-us")({
  component: About,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:image", content: IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: IMAGE },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
});
